// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseElement } from './BaseElement';
import { ProductComponent } from '../../../../../com/MetaPattern/MDA/MD/ProductModel/ProductComponent';
import { WorkScope } from './WorkScope';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 产品 实体类
 * 产品
 */
export class Product extends BaseElement {
  /** 图标 : 图标地址 */
  private _logo: string;

  /** 设置：图标 */
  public get logo() {
    return this._logo;
  }

  /** 获取：图标 */
  public set logo(value: string) {
    this._logo = value;
  }

  /** 根名字空间 : 根名字空间 */
  private _rootNamespace: string;

  /** 设置：根名字空间 */
  public get rootNamespace() {
    return this._rootNamespace;
  }

  /** 获取：根名字空间 */
  public set rootNamespace(value: string) {
    this._rootNamespace = value;
  }

  /** 产品组件 */
  private _productComponents: Array<ProductComponent>;

  /** 获取：产品组件 */
  public get productComponents() {
    return this._productComponents;
  }

  /** 设置：产品组件 */
  public set productComponents(value: Array<ProductComponent>) {
    this._productComponents = value;
  }

  /** 工作空间 的ID */
  private _workScope_ID: string;

  /** 获取：工作空间 的ID */
  public get workScope_ID() {
    return this._workScope_ID;
  }

  /** 设置：工作空间 的ID */
  public set workScope_ID(value: string) {
    this._workScope_ID = value;
  }

  /** 工作空间  */
  private _workScope: WorkScope;

  /** 获取：工作空间  */
  public get workScope() {
    return this._workScope;
  }

  /** 设置：工作空间  */
  public set workScope(value: WorkScope) {
    this._workScope = value;
    if (value !== null) {
      this.workScope_ID = value.id;
    } else {
      this.workScope_ID = '';
    }
  }

  constructor() {
    super();
    this._logo = '';
    this._rootNamespace = '';
    this._productComponents = new Array<ProductComponent>();
    this._workScope_ID = '';
    this._workScope = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Product, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.logo = element.logo;
      this.rootNamespace = element.rootNamespace;
      this.workScope_ID = element.workScope_ID;
      if (hasReference && element.workScope !== null) {
        this.workScope = element.workScope;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.logo = json.Logo;
    this.rootNamespace = json.RootNamespace;
    if (json.ProductComponents && json.ProductComponents.length > 0) {
      json.ProductComponents.forEach((element: any) => {
        const productComponent = ProductComponent.Create(element);
        this.productComponents.push(productComponent);
      });
    }
    this.workScope_ID = json.WorkScope_ID;
    // if (json.WorkScope !== null) {
    //   this.workScope = WorkScope.Create(json.WorkScope);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Logo = this.logo;
    json.RootNamespace = this.rootNamespace;
    if (this.productComponents && this.productComponents.length > 0) {
      json.ProductComponents = [];
      this.productComponents.forEach((element) => {
        json.ProductComponents.push(element.toJson());
      });
    }
    json.WorkScope_ID = this.workScope_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'logo', '图标', EnumDataType.String, this.logo, true, '图标地址', '', '');
    context.addRow('基本属性', 'rootNamespace', '根名字空间', EnumDataType.String, this.rootNamespace, true, '根名字空间', '', '');
    context.addRow('引用', 'workScope', '工作空间', EnumDataType.Reference, this.workScope, true, '', 'WorkScope', 'PGRowWorkScopeValue');
    return context;
  }

  static Create(json: any): Product {
    const product = new Product();
    product.Deserialize(json);
    product.json = json;
    return product;
  }
}
